import React, { useState, type JSX } from 'react';
import { Navigate } from 'react-router';
import { useAppAuth } from '../contexts';
import logo from '../images/logo-blue.svg';
import { APP_LOGIN_PATH } from '../utils/appLogin';
import { clearRealmHint, readRealmHint } from '../utils/realmHint';
import './Login.css';

/**
 * Where logout lands (EPD-79).
 *
 * Logout keeps the saved SSO tenant, so "Sign in" goes straight to the user's
 * IdP. Landing on /login instead would do that immediately, signing the user
 * back in through an IdP session logout does not end. "Use a different
 * account" forgets the tenant so /login shows the email form.
 */
export default function SignedOut(): JSX.Element {
  const { isAuthenticated, isLoading } = useAppAuth();
  const [hasSavedTenant] = useState(() => readRealmHint() !== null);

  if (!isLoading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-page">
      <div className="login-page__card">
        <img className="login-page__logo" src={logo} alt="ept AI" />
        <h1 className="login-page__title">You&apos;re signed out</h1>
        <p className="login-page__subtitle">You can close this tab.</p>
        <div className="login-page__form">
          {/* A full navigation, so /login starts from a clean signed-out state. */}
          <a className="login-page__submit login-page__button-link" href={APP_LOGIN_PATH}>
            Sign in again
          </a>
          {hasSavedTenant ? (
            // Forget the tenant before the link navigates, so /login shows the email form.
            <a className="login-page__secondary" href={APP_LOGIN_PATH} onClick={clearRealmHint}>
              Use a different account
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
